import { tdwSingle as tdwSingleReport } from '@tencent/tencent-doc-report';
// 上报tdw，数据上报配置：https://docs.qq.com/sheet/DSE9yUGZVck5qa3pi?tab=hogs5e
export var report = function (param) {
    var data = param;
    tdwSingleReport(data);
};
